<!-- 首页 -->
<template>
  <div class="frame">
    <div class="banner">
      <div class="bg"></div>
      <div class="banner_overlay"></div>
      <div class="banner_inner">
        <div class="banner_desc">
          <div class="accent_line"></div>
          <div class="text1" :class="{ jp: isJp }">
            <span class="title_line1">{{ $t("message.home.title") }}</span>
          </div>
          <div class="text2">
            <p>{{ $t("message.home.subTitleLine1") }}</p>
            <p>{{ $t("message.home.subTitleLine2") }}</p>
          </div>
          <button class="cta_btn" type="button" @click="navToManager">
            {{ $t("message.home.btnText") }} →
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isJp() {
      return this.$i18n.locale === "jp";
    },
  },
  methods: {
    navToManager() {
      this.$router.push("/manager");
    },
  },
};
</script>
<style lang='scss' scoped>
$home-header-height: 80px;

.frame {
  min-height: calc(100vh - #{$home-header-height});
}

.banner {
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: calc(100vh - #{$home-header-height});
  height: calc(100vh - #{$home-header-height});

  .bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-image: url("../assets/home_bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }

  .banner_overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
  }

  .banner_inner {
    position: absolute;
    inset: 0;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    align-items: center;
  }

  .banner_desc {
    max-width: 560px;
    text-align: left;
  }

  .accent_line {
    width: 48px;
    height: 3px;
    background-color: $theme;
    margin-bottom: 20px;
  }

  .text1 {
    color: $text-dark;
    margin-bottom: 24px;

    .title_line1 {
      display: block;
      font-family: 思源黑体, "Microsoft YaHei", sans-serif;
      font-weight: 700;
      font-size: 38px;
      line-height: 1.4;
    }

    &.jp .title_line1 {
      font-size: 34px;
    }
  }

  .text2 {
    color: $text-dark;
    margin-bottom: 24px;

    p {
      display: block;
      margin: 0;
      font-family: 思源黑体, "Microsoft YaHei", sans-serif;
      font-weight: 700;
      font-size: 15px;
      line-height: 1.4;
      color: $text-dark;
    }
  }

  .cta_btn {
    display: inline-block;
    min-width: 140px;
    height: 44px;
    padding: 0 28px;
    border: none;
    background-color: $subTheme;
    color: #fff;
    font-size: 15px;
    letter-spacing: 1px;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #8f6844;
    }
  }
}

@include respond-md {
  .frame {
    min-height: auto;
  }

  .banner {
    min-height: 520px;
    height: 520px;

    .bg {
      background-size: cover;
      background-position: center center;
    }

    .banner_overlay {
    }

    .banner_inner {
      padding: 0 16px;
      align-items: flex-end;
      padding-bottom: 40px;
    }

    .text1 .title_line1 {
      font-size: 26px;
    }

    .text1.jp .title_line1 {
      font-size: 24px;
    }

    .text2 {
      margin-bottom: 24px;

      p {
        font-size: 14px;
      }
    }
  }
}

@include respond-sm {
  .banner {
    min-height: 340px;
    height: 65vw;
    max-height: 420px;

    .bg {
      background-size: cover;
      background-position: center center;
    }

    .banner_inner {
      align-items: center;
      padding-bottom: 0;
      padding-top: 24px;
    }

    .banner_desc {
      max-width: 100%;
    }

    .text1 {
      margin-bottom: 16px;

      .title_line1 {
        font-size: 22px;
      }
    }

    .text1.jp .title_line1 {
      font-size: 20px;
    }

    .text2 {
      margin-bottom: 16px;

      p {
        font-size: 13px;
      }
    }

    .accent_line {
      margin-bottom: 14px;
    }
  }
}
</style>
